import React, { FC } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useAppSelector } from '../../../hooks/redux';

interface AnimatedIconProps {
  lightIcon: object;
  darkIcon: object;
  className?: string;
  loop?: boolean;
}

export const AnimatedIcon: FC<AnimatedIconProps> = ({ lightIcon, loop, darkIcon, className }) => {
  const { theme } = useAppSelector((state) => state.appReducer);

  return (
    <Player src={theme === 'light' ? lightIcon : darkIcon} autoplay loop={!!loop} className={className} keepLastFrame />
  );
};
